import './cases.component.scss'

import $ from 'jquery'

import 'swiper/css'
import 'swiper/css/navigation'
import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

$(document).ready(function () {
  let slider;
  $(document).on('click', '.case__link', function (e) {
    e.preventDefault();
    let template = '';
    $('.cases__list .case').each(function (index) {
      $(this).data('index', index);
      template += `<div class="swiper-slide"><div class="case case--big">${$(this).html()}</div></div>`;
    });
    $('.cases-popup .swiper-wrapper').html(template);
    $('.cases-popup .swiper-wrapper .case .case__link').remove();
    const num = $(this).parents('.case').data('index');
    $('.cases-popup').addClass('cases-popup--show');
    slider = new Swiper('.cases-popup .swiper-container', {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      spaceBetween: 50,
      navigation: {
        prevEl: '.cases-popup .cases-popup__prev',
        nextEl: '.cases-popup .cases-popup__next'
      }
    });
    slider.slideTo(num + 1, 0);
    disableBodyScroll($('.cases-popup').find('.cases-popup__content')[0]);
    $('body').addClass('blured');
  });
  $('.cases-popup__close').click(function () {
    clearAllBodyScrollLocks();
    $('.cases-popup').removeClass('cases-popup--show');
    $('.cases-popup .swiper-wrapper').html('');
    slider.destroy();
    $('body').removeClass('blured');
  });

  if ($('.cases__form').length > 0) {
    $(window).scroll(function () {
      if ($(this).width() > 1024) {
        $('.cases__form input:focus').blur();
      }
    });
  }
});
